import { combineReducers } from "redux";
import reportReducer from "./reportReducer";

const repReducer = combineReducers({
    report: reportReducer

});

export default repReducer;
